import loadReduxAction from 'modules/redux/actions/load'
import getPathFromDomainPathReduxUtil from 'modules/redux/utils/get-path-from-domain-map-path'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import { TRAINING_PLAN_CLASS_NAME } from 'modules/training/models/plan/constants'
import {
  PLANS_ACTION,
  PLANS_DOMAIN,
  PLANS_ENDPOINT,
  PLANS_PATH
} from 'modules/plan/redux/constants'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import { logUtil } from 'packages/src'

/**
 * @param id
 * @param match
 * @param options
 * @param queryParams
 * @returns {(function(*, *): Promise<void>)|*}
 */
export default function loadByIdPlanAction ({
  id,
  match,
  options,
  queryParams
}) {
  return async (dispatch) => {
    id = (id || match?.params?.id)
    const logPrefix = `id=${id}`
    const debugProps = {
      options,
      queryParams
    }
    logUtil('loadByIdPlanAction').debug(`${logPrefix} [start] debugProps=`, debugProps)
    if (!id) {
      logUtil('loadByIdPlanAction').warn(`${logPrefix} [noop] no id`)
      return
    }

    const endpoint = getEndpointTrainingUtil(
      interpolateRouteUtil(PLANS_ENDPOINT.LOAD_BY_ID, { id }),
      queryParams
    )

    const data = {
      id,
      className: TRAINING_PLAN_CLASS_NAME
    }

    try {
      await dispatch(
        loadReduxAction({
          type: PLANS_ACTION.LOAD_BY_ID,
          payload: {
            endpoint,
            domainListPath: PLANS_PATH.ALL,
            path: getPathFromDomainPathReduxUtil(PLANS_DOMAIN, id),
            data
          },
          options
        })
      )
      logUtil('loadByIdPlanAction').debug(`${logPrefix} [done]`)
    } catch (error) {
      logUtil('loadByIdPlanAction').error(`${logPrefix} error=`, error)
    }
  }
}
